export const validateAadharNumber = (aadhar: string): { isValid: boolean; error?: string } => {
  if (!aadhar.trim()) return { isValid: true };
  
  if (!/^\d+$/.test(aadhar)) {
    console.log(aadhar);
    return { isValid: false, error: 'Aadhar number must contain only digits' };
  }
  
 
  return { isValid: true };
};